<template>
  <div :class="['header', { active: token }]">
    <el-image class="header-log" :src="log_img"></el-image>
    <h2 class="header-title">中知云评估系统</h2>

    <div v-if="token" class="header-info align-center">
      <el-image class="mr-20" :src="require('@/assets/image/tree.png')"></el-image>
      <span>欢迎您：{{ user_info.user_name }}</span>

      <el-button class="logout-box" type="text" icon="el-icon-switch-button" @click="logout">
        退出账号
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["token", "user_info"]),

    log_img() {
      return this.token ? require("@/assets/image/logo2.png") : require("@/assets/image/logo.png");
    }
  },
  methods: {
    async logout() {
      this.$confirm("您确定要退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        lockScroll: false
      })
        .then(async () => {
          await this.$store.dispatch("user/logout");
          this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.header {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5%;
  &.active {
    color: #fff;
    background: url("~@/assets/image/top.jpg") no-repeat;
    background-size: cover;
    .header-title {
      color: #fff;
    }
  }
  .header-title {
    position: absolute;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);

    font-size: 38px;
    font-family: Microsoft YaHei;
    color: rgba(28, 133, 223, 1);
    font-weight: normal;
  }
  .header-info {
    .logout-box {
      color: #fff;
      margin-left: 20px;
      font-size: 16px;
    }
  }
}
</style>
